import { render } from "./PageManualConfig.vue?vue&type=template&id=6a7efaf0"
import script from "./PageManualConfig.vue?vue&type=script&lang=js"
export * from "./PageManualConfig.vue?vue&type=script&lang=js"
script.render = render

export default script